import React from 'react';
import { Sidebar } from '../../../layout/sidebar/sidebar';
import {
  ContentWrapper,
  LayoutContainer,
  NavbarAndContentContainer,
  NavbarContainer,
  StepAndProgressContainer,
  ContentAndButtonsContainer,
  ButtonsContainer,
  TitleAndSubtitle,
  ContentButtonsWrapper,
} from '../../../layout/layout-container.styled';
import { Navbar } from '../../../layout/visitor-log/navbar';
import { NavButton } from '../../../nav-button/nav-button';
import { Text, font } from '../../../../style-utils/text';
import { StyledInput } from '../../../styled-input/styled-input';
import { VisitorLogState } from '../../../hooks/use-visitor-log-handler';
import { DefaultComponentProps } from '../../../app-router/component-props';
import { Step } from '../../../step/step';
import { findPathIndex } from './controllers/find-path-index';
import { Progress } from '../../../progress/progress';
import useRedirectOnRefresh from '../../../hooks/use-redirect-on-refresh';
import { useRedirectOnBack } from '../../../hooks/use-redirect-on-back';
import { useWindowHeight } from '../../../../style-utils/use-window-height';

export const NumberOfGuests: React.FC<DefaultComponentProps> = ({
  navigate,
  nextPath,
  prevPath,
  changeHandler,
  state,
  path,
  navigation,
  selectedOption,
  selectedBuilding,
}) => {
  const { numberOfGuests } = state as VisitorLogState;
  const isLog = path?.includes('/daily-log') || false;
  const maxPaths = navigation?.length || 0;
  const currentPathIndex = findPathIndex(path, navigation);
  useRedirectOnRefresh();
  useRedirectOnBack();

  const height = useWindowHeight();

  return (
    <LayoutContainer height={height}>
      <Sidebar
        selectedBuilding={selectedBuilding}
        selectedOption={selectedOption}
        navigate={navigate}
      />
      <ContentWrapper>
        <StepAndProgressContainer>
          <Step currentPathIndex={currentPathIndex} maxPaths={maxPaths || 0} />
          <Progress
            currentPathIndex={currentPathIndex}
            maxPaths={maxPaths || 0}
          />
        </StepAndProgressContainer>
        <NavbarAndContentContainer>
          <NavbarContainer>
            <Navbar
              path={path}
              navigation={navigation}
              state={state}
              isLog={isLog}
              navigate={navigate}
              currentPage={path}
              hasContent
            />
          </NavbarContainer>
          <ContentAndButtonsContainer>
            <TitleAndSubtitle direction="column">
              <Text fontSize={font.size.xl} fontWeight={700} mt={0} mb={10}>
                No. Of Guests
              </Text>
              <Text
                color={font.color.gray}
                fontSize={font.size.xs}
                mt={0}
                mb={0}
              >
                {`Type in the number of guest(s)/people`}
              </Text>
            </TitleAndSubtitle>
            <ContentButtonsWrapper>
              <StyledInput
                maxLength={2}
                width={70}
                placeholder={''}
                type="number"
                defaultValue={1}
                name={'numberOfGuests'}
                // eslint-disable-next-line
                onChange={(e: any) => changeHandler(e, 'numberOfGuests')}
              />
            </ContentButtonsWrapper>
            <ButtonsContainer>
              <NavButton
                disabled={false}
                direction="back"
                textColor="#637083"
                background="transparent"
                text={'Back'}
                onClick={() => navigate(prevPath, { replace: false })}
              />
              <NavButton
                disabled={numberOfGuests < 1}
                direction="forward"
                textColor={'white'}
                background={font.color.purple}
                text={'Continue'}
                onClick={() => navigate(nextPath, { replace: false })}
              />
            </ButtonsContainer>
          </ContentAndButtonsContainer>
        </NavbarAndContentContainer>
      </ContentWrapper>
    </LayoutContainer>
  );
};
